/** Role & menu constants for Steward Learning Cloud. */

export const ROLES = {
  SUPER_ADMIN: "super_admin",
  HOSPITAL_ADMIN: "hospital_admin",
  FACULTY: "faculty",
  DEPARTMENT_HEAD: "department_head",
  STUDENT: "student",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  hospital_admin: "Institute Admin",
  faculty: "Faculty",
  department_head: "Dept. Head",
  student: "Learner",
};

export const ROLE_HOME = {
  super_admin: "/app/super-admin",
  hospital_admin: "/app/hospital",
  faculty: "/app/faculty",
  department_head: "/app/department",
  student: "/app/learner",
};

export const SIDEBAR_MENUS = {
  super_admin: [
    { label: "Dashboard", to: "/app/super-admin", icon: "LayoutDashboard" },
    { label: "Users", to: "/app/super-admin/users", icon: "Users" },
    { label: "All Staff", to: "/app/super-admin/staff", icon: "UsersRound" },
    { label: "Organizations", to: "/app/super-admin/organizations", icon: "Building2" },
    { label: "Roles & Permissions", to: "/app/super-admin/roles", icon: "ShieldCheck" },
    { label: "Course Dashboard", to: "/app/super-admin/courses/dashboard", icon: "GraduationCap" },
    { label: "Categories", to: "/app/super-admin/courses/categories", icon: "FolderTree" },
    { label: "Courses", to: "/app/super-admin/courses", icon: "BookOpen" },
    { label: "Course Mappings", to: "/app/super-admin/courses/mappings", icon: "Network" },
    { label: "Exam Dashboard", to: "/app/super-admin/exams/dashboard", icon: "FileCheck" },
    { label: "Question Bank", to: "/app/super-admin/question-bank", icon: "HelpCircle" },
    { label: "Exams", to: "/app/super-admin/exams", icon: "ClipboardList" },
    { label: "Exam Results", to: "/app/super-admin/exam-results", icon: "Award" },
    { label: "Certificate Dashboard", to: "/app/super-admin/certificates/dashboard", icon: "Award" },
    { label: "Certificate Templates", to: "/app/super-admin/certificate-templates", icon: "Palette" },
    { label: "Certificate Register", to: "/app/super-admin/certificates", icon: "ClipboardList" },
    { label: "Certificate Renewals", to: "/app/super-admin/certificate-renewals", icon: "RefreshCw" },
    { label: "Platform Analytics", to: "/app/super-admin/analytics", icon: "BarChart3" },
    { label: "Global Training Matrix", to: "/app/super-admin/reports/training-matrix", icon: "Layers" },
    { label: "Student Doubts", to: "/app/faculty/doubts", icon: "MessageSquare" },
    { label: "AI Dashboard", to: "/app/super-admin/ai/dashboard", icon: "Sparkles" },
    { label: "AI Assistant", to: "/app/super-admin/ai/assistant", icon: "Bot" },
    { label: "AI Providers", to: "/app/super-admin/ai/providers", icon: "Cpu" },
    { label: "AI Prompt Templates", to: "/app/super-admin/ai/prompt-templates", icon: "FileText" },
    { label: "AI Feature Settings", to: "/app/super-admin/ai/settings", icon: "SlidersHorizontal" },
    { label: "AI Usage Logs", to: "/app/super-admin/ai/usage-logs", icon: "Activity" },
    { label: "AI Generated Questions", to: "/app/super-admin/ai/generated-questions", icon: "Wand2" },
    { label: "Revenue Dashboard", to: "/app/super-admin/revenue", icon: "IndianRupee" },
    { label: "Payment Gateways", to: "/app/super-admin/payment-gateways", icon: "CreditCard" },
    { label: "Coupons", to: "/app/super-admin/coupons", icon: "Tag" },
    { label: "Subscription Plans", to: "/app/super-admin/subscription-plans", icon: "Package" },
    { label: "Orders", to: "/app/super-admin/orders", icon: "ShoppingCart" },
    { label: "Invoices", to: "/app/super-admin/invoices", icon: "Receipt" },
    { label: "Refunds", to: "/app/super-admin/refunds", icon: "RefreshCw" },
    { label: "Platform Settings", to: "/app/super-admin/settings", icon: "SlidersHorizontal" },
    { label: "Site Pages (show/hide)", to: "/app/super-admin/site-pages", icon: "Eye" },
    { label: "CMS / Website", to: "/app/super-admin/cms", icon: "Globe" },
    { label: "Audit Logs", to: "/app/super-admin/audit-logs", icon: "ScrollText" },
    { label: "System Health", to: "/app/super-admin/system-health", icon: "Activity" },
    { label: "Notifications", to: "/app/super-admin/notifications", icon: "Bell" },
    { label: "Future Modules", to: "/app/super-admin/future-modules", icon: "Sparkles" },
    { label: "Inquiries", to: "/app/super-admin/inquiries", icon: "MessageSquare" },
    { label: "Video Library", to: "/app/super-admin/video-library", icon: "Film" },
    { label: "Social Integrations", to: "/app/super-admin/integrations/social", icon: "Share2" },
    { label: "Partnership Enquiries", to: "/app/super-admin/partnership-enquiries", icon: "Building2" },
    { label: "SMTP / Email Settings", to: "/app/super-admin/master/smtp", icon: "Mail" },
    { label: "Homepage Logos", to: "/app/super-admin/master/homepage-logos", icon: "Image" },
    { label: "Legal Pages", to: "/app/super-admin/master/legal-pages", icon: "FileText" },
    { label: "Installment Plans", to: "/app/super-admin/installments", icon: "Wallet" },
    { label: "White Label", to: "/app/super-admin/white-label", icon: "Palette" },
    { label: "WL Settings", to: "/app/super-admin/white-label/settings", icon: "Settings2" },
    { label: "Branding Approvals", to: "/app/super-admin/white-label/approvals", icon: "ShieldCheck" },
    { label: "Domain Management", to: "/app/super-admin/white-label/domains", icon: "Globe" },
    { label: "Production Readiness", to: "/app/super-admin/prod/readiness", icon: "Rocket" },
    { label: "Health Summary", to: "/app/super-admin/prod/health", icon: "Activity" },
    { label: "Monitoring", to: "/app/super-admin/prod/monitoring", icon: "TrendingUp" },
    { label: "Error Logs", to: "/app/super-admin/prod/errors", icon: "AlertTriangle" },
    { label: "Backups", to: "/app/super-admin/prod/backups", icon: "HardDrive" },
    { label: "Restore", to: "/app/super-admin/prod/restore", icon: "RefreshCw" },
    { label: "Release Notes", to: "/app/super-admin/prod/releases", icon: "Rocket" },
    { label: "QA Test Cases", to: "/app/super-admin/prod/qa", icon: "ClipboardCheck" },
    { label: "UAT Feedback", to: "/app/super-admin/prod/uat", icon: "MessageSquare" },
    { label: "Maintenance Mode", to: "/app/super-admin/prod/maintenance", icon: "Settings" },
    { label: "Launch Checklist", to: "/app/super-admin/prod/launch", icon: "CheckCircle2" },
    { label: "Settings", to: "/app/settings", icon: "Settings" },
  ],
  hospital_admin: [
    { label: "Dashboard", to: "/app/hospital", icon: "LayoutDashboard" },
    { label: "Organization Profile", to: "/app/hospital/profile", icon: "Building2" },
    { label: "Departments", to: "/app/hospital/departments", icon: "Building" },
    { label: "Branding", to: "/app/hospital/branding", icon: "Palette" },
    { label: "Onboarding", to: "/app/hospital/onboarding", icon: "ClipboardCheck" },
    { label: "Staff Dashboard", to: "/app/hospital/staff/dashboard", icon: "UsersRound" },
    { label: "All Staff", to: "/app/hospital/staff", icon: "Users" },
    { label: "Bulk Upload", to: "/app/hospital/staff/import", icon: "UploadCloud" },
    { label: "Designations", to: "/app/hospital/designations", icon: "IdCard" },
    { label: "Course Dashboard", to: "/app/hospital/courses/dashboard", icon: "GraduationCap" },
    { label: "Mapped Courses", to: "/app/hospital/courses", icon: "BookOpen" },
    { label: "Assignments", to: "/app/hospital/course-assignments", icon: "ClipboardList" },
    { label: "Bulk Assign", to: "/app/hospital/courses/bulk-assign", icon: "UsersRound" },
    { label: "Learning Progress", to: "/app/hospital/learning-progress", icon: "LineChart" },
    { label: "Exam Dashboard", to: "/app/hospital/exams/dashboard", icon: "FileCheck" },
    { label: "Available Exams", to: "/app/hospital/exams", icon: "ClipboardList" },
    { label: "Exam Assignments", to: "/app/hospital/exam-assignments", icon: "ClipboardCheck" },
    { label: "Exam Results", to: "/app/hospital/exam-results", icon: "Award" },
    { label: "Certificate Register", to: "/app/hospital/certificate-register", icon: "ShieldCheck" },
    { label: "Compliance Dashboard", to: "/app/hospital/reports/compliance", icon: "BarChart3" },
    { label: "Training Matrix", to: "/app/hospital/reports/training-matrix", icon: "Layers" },
    { label: "Staff Training", to: "/app/hospital/reports/staff-training", icon: "ClipboardList" },
    { label: "Course Completion", to: "/app/hospital/reports/course-completion", icon: "TrendingUp" },
    { label: "Exam Results Report", to: "/app/hospital/reports/exam-results", icon: "FileCheck" },
    { label: "Certificate Expiry", to: "/app/hospital/reports/certificate-expiry", icon: "Clock" },
    { label: "Mandatory Compliance", to: "/app/hospital/reports/mandatory-compliance", icon: "ShieldCheck" },
    { label: "Audit Reports", to: "/app/hospital/reports/audit", icon: "FileSpreadsheet" },
    { label: "AI Assistant", to: "/app/hospital/ai/assistant", icon: "Bot" },
    { label: "AI Compliance Insights", to: "/app/hospital/ai/compliance-insights", icon: "Sparkles" },
    { label: "AI Predictive Risk", to: "/app/hospital/ai/predictive-risk", icon: "AlertTriangle" },
    { label: "Billing", to: "/app/hospital/billing", icon: "IndianRupee" },
    { label: "Organization Invoices", to: "/app/hospital/billing/invoices", icon: "Receipt" },
    { label: "AI Usage Billing", to: "/app/hospital/billing/ai-usage", icon: "Sparkles" },
    { label: "Announcements", to: "/app/hospital/announcements", icon: "Megaphone" },
    { label: "Notification Settings", to: "/app/hospital/notification-settings", icon: "Bell" },
    { label: "Compliance", to: "/app/hospital/compliance", icon: "ShieldCheck", disabled: true, badge: "Phase 9" },
    { label: "WL: Branding", to: "/app/hospital/wl/branding", icon: "Palette" },
    { label: "WL: Domains", to: "/app/hospital/wl/domains", icon: "Globe" },
    { label: "WL: Login Page", to: "/app/hospital/wl/login", icon: "LayoutDashboard" },
    { label: "WL: Policy Pages", to: "/app/hospital/wl/policies", icon: "FileText" },
    { label: "WL: Certificate Branding", to: "/app/hospital/wl/certificate-branding", icon: "Award" },
    { label: "WL: Status History", to: "/app/hospital/wl/history", icon: "ScrollText" },
    { label: "UAT Feedback", to: "/app/uat/feedback", icon: "MessageSquare" },
    { label: "Settings", to: "/app/settings", icon: "Settings" },
  ],
  faculty: [
    { label: "Dashboard", to: "/app/faculty", icon: "LayoutDashboard" },
    { label: "My Courses", to: "/app/faculty/courses", icon: "BookOpen" },
    { label: "Live Classes", to: "/app/faculty/live-classes", icon: "Video" },
    { label: "Student Doubts", to: "/app/faculty/doubts", icon: "MessageSquare" },
    { label: "My Learning", to: "/app/learner/courses", icon: "GraduationCap" },
    { label: "Question Bank", to: "/app/faculty/question-bank", icon: "HelpCircle" },
    { label: "Evaluation", to: "/app/faculty/evaluation", icon: "ClipboardCheck" },
    { label: "Student Progress", to: "/app/faculty/analytics", icon: "LineChart" },
    { label: "AI Assistant", to: "/app/faculty/ai/assistant", icon: "Bot" },
    { label: "AI Question Generator", to: "/app/faculty/ai/question-generator", icon: "Wand2" },
    { label: "Announcements", to: "/app/faculty/announcements", icon: "Megaphone" },
    { label: "UAT Feedback", to: "/app/uat/feedback", icon: "MessageSquare" },
    { label: "Settings", to: "/app/settings", icon: "Settings" },
  ],
  department_head: [
    { label: "Dashboard", to: "/app/department", icon: "LayoutDashboard" },
    { label: "My Courses", to: "/app/learner/courses", icon: "BookOpen" },
    { label: "My Bookmarks", to: "/app/learner/bookmarks", icon: "Bookmark" },
    { label: "Live Classes", to: "/app/learner/live-classes", icon: "Video" },
    { label: "Staff Progress", to: "/app/department/staff", icon: "UsersRound", disabled: true, badge: "Phase 9" },
    { label: "Reports", to: "/app/department/reports", icon: "BarChart3", disabled: true, badge: "Phase 9" },
    { label: "UAT Feedback", to: "/app/uat/feedback", icon: "MessageSquare" },
    { label: "Settings", to: "/app/settings", icon: "Settings" },
  ],
  student: [
    { label: "Dashboard", to: "/app/learner", icon: "LayoutDashboard" },
    { label: "My Courses", to: "/app/learner/courses", icon: "BookOpen" },
    { label: "My Bookmarks", to: "/app/learner/bookmarks", icon: "Bookmark" },
    { label: "Live Classes", to: "/app/learner/live-classes", icon: "Video" },
    { label: "My Exams", to: "/app/learner/exams", icon: "FileCheck" },
    { label: "My Certificates", to: "/app/learner/certificates", icon: "Award" },
    { label: "My Transcript", to: "/app/learner/transcript", icon: "ClipboardList" },
    { label: "AI Study Assistant", to: "/app/learner/ai/study-assistant", icon: "Bot" },
    { label: "AI Learning Studio", to: "/app/learner/ai/studio", icon: "Sparkles" },
    { label: "My Weak Topics", to: "/app/learner/ai/weak-topics", icon: "AlertTriangle" },
    { label: "AI Recommendations", to: "/app/learner/ai/recommendations", icon: "Lightbulb" },
    { label: "AI Chat History", to: "/app/learner/ai/chat-history", icon: "MessageSquare" },
    { label: "Cart", to: "/app/learner/cart", icon: "ShoppingCart" },
    { label: "My Orders", to: "/app/learner/orders", icon: "Receipt" },
    { label: "My Installments", to: "/app/student/installments", icon: "Wallet" },
    { label: "My Invoices", to: "/app/learner/invoices", icon: "FileText" },
    { label: "Notifications", to: "/app/notifications", icon: "Bell" },
    { label: "Notification Preferences", to: "/app/settings/notifications", icon: "SlidersHorizontal" },
    { label: "UAT Feedback", to: "/app/uat/feedback", icon: "MessageSquare" },
    { label: "Profile", to: "/app/settings/profile", icon: "User" },
    { label: "Help", to: "/app/help", icon: "HelpCircle" },
  ],
};

export const LOGO_URL = "/sihmt-logo.png";
